import { HBAK } from "@constants/common";
import Honeybadger from "@honeybadger-io/js";
import { decryptKey, getCurrentReporterVersion, reportToHoneybadger, } from "@utils/common";
import consoleLogFormatted from "@utils/consoleLogFormatted";
import { AxiosError } from "axios";
import { onBegin } from "lifecycle/onBegin";
import { onEnd } from "lifecycle/onEnd";
import { onTestBegin } from "lifecycle/onTestBegin";
import { onTestEnd } from "lifecycle/onTestEnd";
import test from "./fixtures";
import { initialize } from "./lifecycle/initialize";
class NeetoPlaywrightReporter {
    constructor(options) {
        var _a;
        this.reportLifecycleError = async (lifecycle, error, additionalContext = {}) => {
            var _a, _b, _c;
            let errorMessage = null;
            if (error instanceof AxiosError) {
                errorMessage = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) !== null && _c !== void 0 ? _c : error === null || error === void 0 ? void 0 : error.message;
            }
            consoleLogFormatted.error(`${lifecycle} failed: ${errorMessage !== null && errorMessage !== void 0 ? errorMessage : String(error)}`);
            await reportToHoneybadger({
                context: {
                    lifecycle,
                    ciBuildId: this.ciBuildId,
                    ...additionalContext,
                },
                error,
                title: `${lifecycle} - Fire and Forget Handler`,
            });
        };
        this.onBegin = (config, rootSuite) => {
            onBegin(this, config, rootSuite).catch(error => this.reportLifecycleError("onBegin", error, {
                configDetails: JSON.stringify(config, null, 2),
            }));
        };
        this.onTestBegin = (test, result) => {
            onTestBegin(this, test, result).catch(error => this.reportLifecycleError("onTestBegin", error, {
                testTitle: test.title,
                testLocation: test.location,
            }));
        };
        this.onTestEnd = (testCase, testResult) => {
            onTestEnd(this, testCase, testResult).catch(error => this.reportLifecycleError("onTestEnd", error, {
                testTitle: testCase.title,
                testLocation: testCase.location,
                testStatus: testResult.status,
                testDuration: testResult.duration,
            }));
        };
        this.onEnd = (fullResult) => onEnd(this, fullResult);
        const parseTagsFromEnv = () => {
            const envTags = process.env.NEETO_PLAYDASH_TAGS;
            if (!envTags)
                return undefined;
            if (envTags.includes(",")) {
                return envTags.split(",");
            }
            return envTags;
        };
        const resolvedOptions = {
            projectKey: options.projectKey || process.env.NEETO_PROJECT_KEY || "",
            baseURL: options.baseURL || process.env.NEETO_PLAYDASH_API_BASE_URL || "",
            apiKey: options.apiKey || process.env.NEETO_API_KEY || "",
            ciBuildId: options.ciBuildId || process.env.NEETO_CI_BUILD_ID || "",
            tags: options.tags || parseTagsFromEnv() || [],
            title: options.title || process.env.NEETO_PLAYDASH_TITLE,
            commitId: options.commitId || process.env.NEETO_PLAYDASH_COMMIT_ID,
            author: options.author || process.env.NEETO_PLAYDASH_AUTHOR,
            branch: options.branch || process.env.NEETO_PLAYDASH_BRANCH,
        };
        this.attempts = {};
        this.tags = resolvedOptions.tags;
        this.ciBuildId = resolvedOptions.ciBuildId;
        this.title = resolvedOptions.title;
        this.commitId = resolvedOptions.commitId;
        this.author = resolvedOptions.author;
        this.branch = resolvedOptions.branch;
        this.testResultCalls = [];
        this.totalTestCount = 0;
        this.hasRunStarted = false;
        this.heartbeatManager = null;
        this.rootDir = "";
        this.currentShard = 0;
        this.progressBars = [];
        this.startedAttempts = new Set();
        this.shouldNotReportTest = false;
        this.pendingTestBegins = new Set();
        this.pendingTestEnds = new Set();
        this.apiKey = resolvedOptions.apiKey;
        Honeybadger.configure({
            apiKey: decryptKey(HBAK),
            environment: ((_a = resolvedOptions === null || resolvedOptions === void 0 ? void 0 : resolvedOptions.baseURL) === null || _a === void 0 ? void 0 : _a.includes(".net"))
                ? "staging"
                : "production",
        });
        Honeybadger.setContext({
            ...resolvedOptions,
            reporterVersion: getCurrentReporterVersion(),
        });
        initialize(this, resolvedOptions);
    }
    onStdOut(chunk, test) {
        test && consoleLogFormatted.bold(`Log from test "${test.title}"`);
        consoleLogFormatted.log(chunk.toString());
    }
}
export default NeetoPlaywrightReporter;
export { test };
//# sourceMappingURL=index.js.map